import React, { Component } from "react";
import { Card, Button, Image } from "semantic-ui-react";
import PropTypes from "prop-types";
import ApexCharts from "apexcharts";
import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import { connect } from "react-redux";
import { solveProblemAction } from "../../actions/changeActiveItemActions";

let asiWaveFormOptions = {
  series: [{ data: [] }],
  chart: {
    id: Constants.CHART_ID,
    type: "line",
  },
  colors: [Constants.YELLOW_HEX],
  markers: {
    size: 0
  },
  dataLabels: {
    enabled: false
  },
  title: {
    text: Strings.WAVE_FORM,
    align: "center"
  },
  stroke: {
    curve: "straight",
    width: 2
  },
  xaxis: {
    type: "numeric",
    title: {
      text: Strings.TIME_NS
    },
    crosshairs: {
      show: "true"
    },
    labels: {
      show: true,
      style: {
        fontSize: Constants.LABELS_FONT_SIZE
      }
    }
  },
  yaxis: {
    min: -5,
    max: 5,
    labels: {
      show: true,
      formatter: function (val) {
        return val.toFixed(2).replace(".", ",") + " " + Strings.MILLIVOLT;
      },
      style: {
        fontSize: Constants.LABELS_FONT_SIZE
      }
    },
    title: {
      text: Strings.VOLTAGE_V
    },
  },
  annotations: {
    position: "front",
    xaxis: []
  }
};

export class ProblemCard extends Component {
  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      waveImg: "",
    };
  }

  getProblemHeader = () => {
    if (this.props.problem.type === Constants.ASI_DEVIATION_PROBLEM_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.ASI_DEVIATION_LIST_HEADER}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.ASI_ATTENUATED_SIGNAL_PROBLEM_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.ASI_ATTENUATED_SIGNAL_LIST_HEADER}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.ASI_NOISE_PROBLEM_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.ASI_NOISE_LIST_HEADER}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.ASI_RETRY_PROBLEM_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.ASI_RETRY_LIST_HEADER}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.ASI_FAULT_PROBLEM_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.ASI_FAULT_LIST_HEADER}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.ASI_INVERTED_POLARITY_PROBLEM_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.ASI_INVERTED_POLARITY_LIST_HEADER}
        </Card.Header>
      );
    }
    else {
      return "";
    }
  }

  formatTime = () => {
    if (this.props.problem.ntp !== null && this.props.problem.ntp === true) {
      let parsedMillis = Date.parse(this.props.problem.time);
      let dateToShow = new Date(parsedMillis);
      return dateToShow.toLocaleString("pt-BR");
    }
    else if (this.props.problem.time !== undefined && this.props.problem.time !== null) {
      const eventTimeInMillis = this.props.problem.time * 1000;
      const timeNow = this.props.nowMillis;
      const time = timeNow - eventTimeInMillis;
      const dateToShow = new Date(time);
      return (dateToShow.toLocaleString("pt-BR"));
    }
    else {
      return Strings.BEFORE_MONITOR_INIT_STR;
    }
  }

  getProblemMeta = () => {
    let problemDate = this.formatTime();

    return (
      <Card.Meta>
        <strong>
          {Strings.DETECTED_ON}
          {problemDate}
        </strong>
      </Card.Meta>
    );
  }

  getProblemDescription = () => {
    console.log(this.props.channel);
    if (this.props.problem.type === Constants.ASI_DEVIATION_PROBLEM_TYPE) {
      return (
        <Card.Description style={descriptionStyle}>
          <p><b>{Strings.ADDRESS}:</b> {this.props.problem.address}</p>
          <p><b>{Strings.DEVIATION}:</b> {parseFloat(this.props.problem.deviation).toFixed(2).replace(".", ",")} {Strings.MICROSSECOND}</p>
        </Card.Description>
      );
    }
    else if (this.props.problem.type === Constants.ASI_ATTENUATED_SIGNAL_PROBLEM_TYPE) {
      return (
        <Card.Description style={descriptionStyle}>
          <p><b>{Strings.ADDRESS}:</b> {this.props.problem.address}</p>
          <p><b>{Strings.AMPLITUDE}:</b> {(parseFloat(this.props.problem.amplitude) / 1000).toFixed(2)} V<sub>pp</sub></p>
        </Card.Description>
      );
    }
    else if (this.props.problem.type === Constants.ASI_NOISE_PROBLEM_TYPE) {
      return (
        <Card.Description style={descriptionStyle}>
          <p><b>{Strings.CHANNEL}:</b> {this.props.channel}</p>
        </Card.Description>
      );
    }
    else if (this.props.problem.type === Constants.ASI_RETRY_PROBLEM_TYPE) {
      return (
        <Card.Description style={descriptionStyle}>
          <p><b>{Strings.ADDRESS}:</b> {this.props.problem.address}</p>
          <p><b>{Strings.CHANNEL}:</b> {this.props.channel}</p>
        </Card.Description>
      );
    }
    else if (this.props.problem.type === Constants.ASI_FAULT_PROBLEM_TYPE) {
      return (
        <Card.Description style={descriptionStyle}>
          <p><b>{Strings.ADDRESS}:</b> {this.props.problem.address}</p>
          <p><b>{Strings.CHANNEL}:</b> {this.props.channel}</p>
        </Card.Description>
      );
    }
    else if (this.props.problem.type === Constants.ASI_INVERTED_POLARITY_PROBLEM_TYPE) {
      return (
        <Card.Description style={descriptionStyle}>
          <p><b>{Strings.ADDRESS}:</b> {this.props.problem.address}</p>
          <p><b>{Strings.CHANNEL}:</b> {this.props.channel}</p>
        </Card.Description>
      );
    }
    else {
      return "";
    }
  }

  handleSolvedButtonClick = async () => {
    this.props.onProblemSolve(true, this.props.problem);
  }

  getFormatedASiOptions = (wave, asiWaveFormOptions) => {
    let options = {};

    if (wave[wave.length - 1][0] < 1000) {
      // Set the time values to nanosseconds
      options = {
        ...asiWaveFormOptions,
        xaxis: {
          type: "numeric",
          title: {
            text: Strings.TIME_NS
          },
          crosshairs: {
            show: "true"
          }
        }
      };
    }
    else if (wave[wave.length - 1][0] >= 1000
      && wave[wave.length - 1][0] < 1000000) {
      // Set the time values to microsseconds
      options = {
        ...asiWaveFormOptions,
        xaxis: {
          type: "numeric",
          title: {
            text: Strings.TIME_US
          },
          crosshairs: {
            show: "true"
          }
        }
      };
    }
    else if (wave[wave.length - 1][0] >= 1000000) {
      // Set the time values to millisseconds
      options = {
        ...asiWaveFormOptions,
        xaxis: {
          type: "numeric",
          title: {
            text: Strings.TIME_MS
          },
          crosshairs: {
            show: "true"
          }
        }
      };
    }

    return options;
  }

  formatWaveTimes = (wave) => {
    if (wave[wave.length - 1][0] < 1000) {
      // Set the time values to nanosseconds 
      // (it already is by default, so do nothing here)
    }
    else if (wave[wave.length - 1][0] >= 1000
      && wave[wave.length - 1][0] < 1000000) {
      // Set the time values to microsseconds
      for (let i = 0; i < wave.length; i++) {
        wave[i][0] = wave[i][0] / (10 ** 3);
      }
    }
    else if (wave[wave.length - 1][0] >= 1000000) {
      // Set the time values to millisseconds
      for (let i = 0; i < wave.length; i++) {
        wave[i][0] = wave[i][0] / (10 ** 6);
      }
    }

    return wave;
  }

  getOscilloscopeImgURI = async (wave) => {
    if (wave !== null && wave !== undefined) {

      document.getElementById("chart").style.display = "block";

      // Render the chart
      let chart = new ApexCharts(document.querySelector("#chart"), asiWaveFormOptions);
      chart.render();

      // Render the wave B - A to get its imgURI
      let options = this.getFormatedASiOptions(wave, asiWaveFormOptions);

      options = {
        ...options,
        title: {
          text: Strings.WAVE_FORM,
          align: "center",
          style: {
            fontSize: "14px",
            fontFamily: "Helvetica, Arial, sans-serif"
          }
        },
        colors: [Constants.YELLOW_HEX],
        series: [
          { name: Strings.WAVE_FORM, data: this.formatWaveTimes(wave) }
        ]
      };

      chart.updateOptions(options, false, false, false);

      let imgURIObj = await chart.dataURI();

      document.getElementById("chart").style.display = "none";

      chart.destroy();

      return imgURIObj.imgURI;
    }
    else {
      return Constants.LOADING_IMG;
    }
  }

  setImage = async () => {
    if (this.props.problem.type !== Constants.ASI_INVERTED_POLARITY_PROBLEM_TYPE) {
      let wave = "data:,";

      while (wave === "data:,") {
        wave = await this.getOscilloscopeImgURI(this.props.problem.wave);
      }

      this.setState({ waveImg: wave }, () => {
        let waveImgElement = document.getElementById(this.props.problem._id + " / imgWave");
        waveImgElement.style.visibility = "visible";
        waveImgElement.style.display = "block";
      });
    }
  }

  getEvidenceDescriptionText = () => {
    if (
      this.props.problem.type !== Constants.ASI_RETRY_PROBLEM_TYPE
      && this.props.problem.type !== Constants.ASI_FAULT_PROBLEM_TYPE
      && this.props.problem.type !== Constants.ASI_INVERTED_POLARITY_PROBLEM_TYPE
    ) {
      return <p>{Strings.EVIDENCE_DESCRIPTION}</p>;
    }
  }

  componentDidMount = () => {
    if (
      this.props.problem.type !== Constants.ASI_RETRY_PROBLEM_TYPE
      && this.props.problem.type !== Constants.ASI_FAULT_PROBLEM_TYPE
    ) {
      this.setImage();
    }
  }

  render() {
    return (
      <Card id={this.props.problem._id} fluid raised>
        <Card.Content>

          {this.getProblemHeader()}
          {this.getProblemMeta()}
          {this.getProblemDescription()}

          <Card.Description>
            {this.getEvidenceDescriptionText()}
            <Image
              id={this.props.problem._id + " / imgWave"}
              centered
              src={this.state.waveImg}
              style={hiddenImageStyle}
              onError={() => console.log("Error loading image")}
            />
          </Card.Description>

        </Card.Content>
        <Card.Content extra>
          <Button
            basic
            color='green'
            fluid
            onClick={this.handleSolvedButtonClick}>
            {Strings.CHECKED}
          </Button>
        </Card.Content>
        <div id="chart" style={chartsStyle}></div>
      </Card >
    );
  }
}

const mapActionsToProps = {
  onProblemSolve: solveProblemAction
};

ProblemCard.propTypes = {
  nowMillis: PropTypes.number.isRequired,
  startTime: PropTypes.number.isRequired,
  problem: PropTypes.object.isRequired,
  onProblemSolve: PropTypes.func,
  channel: PropTypes.number.isRequired,
  amplitude: PropTypes.number,
  deviation: PropTypes.number,
};

const chartsStyle = {
  position: "absolute",
  left: "0px",
  top: "0px",
  zIndex: "-1",
  width: "525px",
  height: "250px",
  display: "none",
  visibility: "hidden"
};

const hiddenImageStyle = {
  visibility: "hidden",
  display: "none",
};

const descriptionStyle = {
  marginBottom: "1vh"
};

export default connect(null, mapActionsToProps)(ProblemCard);